<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="BANCOS" key="1">
        <a-row>
          <g-master name="bancos"
                    @params="paramsTable"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <span slot="estadoRenderer" slot-scope="{text}">
              <div v-if="text ==='INACTIVO'">
                <a-tag color="red">{{text}}</a-tag>
              </div>
              <div v-if="text ==='ACTIVO'">
                <a-tag color="blue">{{text}}</a-tag>
              </div>
            </span>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('ID banco')">
                    <a-input style="width: 100%;"
                             v-decorator="['id_bank', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                    <a-input style="width: 100%;"
                             v-decorator="['bank_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Nit')">
                    <a-input style="width: 100%;"
                             v-decorator="['bank_nit', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['bank_status', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="estado">
                  </g-dropdown>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tpay: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        estado: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'banks',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id_bank'
            },
            columns: [
              {title: '#', dataIndex: 'id_bank', sorter: true},
              {title: 'Nombre', dataIndex: 'bank_name', sorter: true},
              {title: 'Nit', dataIndex: 'bank_nit', sorter: true},

              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                scopedSlots: {
                  customRender: 'estadoRenderer'
                }
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'bank_name'},
            {name: 'bank_nit'},
            {name: 'bank_status'},
            {name: 'id_bank'}
          ]
        },
        endpointExcel: 'banks_/downloadExcel',
        fileNameExcel: 'Bancos',
        paramsT: {}
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Bank/Bank.vue